import { memo } from "react";
import type { LoaderCommonProps } from "../types";
import { tokens } from "../styles/tokens";
import { Skeleton } from "./Skeleton";

export const ProfileLoader = memo(function ProfileLoader({
  animated = true,
  width = "100%",
  height,
  className,
}: LoaderCommonProps) {
  return (
    <div
      className={className}
      style={{
        width,
        height,
        background: "#fff",
        borderRadius: tokens.radius,
        boxShadow: tokens.shadowMd,
        padding: tokens.spacing.lg,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: tokens.spacing.md,
      }}
    >
      <Skeleton width={96} height={96} borderRadius={tokens.radiusFull} animated={animated} />
      <Skeleton width={180} height={24} animated={animated} />
      <div
        style={{
          width: "100%",
          maxWidth: 320,
          display: "flex",
          flexDirection: "column",
          gap: tokens.spacing.sm,
          alignItems: "center",
        }}
      >
        <Skeleton width="100%" height={14} animated={animated} />
        <Skeleton width="90%" height={14} animated={animated} />
        <Skeleton width="75%" height={14} animated={animated} />
      </div>
    </div>
  );
});
